// Importing action types
import {
  FETCH_CAREER_REQUEST,
  FETCH_CAREER_SUCCESS,
  FETCH_CAREER_FAILURE,
} from "../../actions/fetchCareerActions";

// Define the initial state for the reducer
const initialState = {
  isCareerItem: null,  // Initial value for isCareerItem is null
  isLoading: false,    // Initial value for isLoading is false
  isError: null,       // Initial value for isError is null
};

// Define the CareerDataReducer function
const CareerDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CAREER_REQUEST:
      // When the FETCH_CAREER_REQUEST action is dispatched
      return {
        ...state,
        isLoading: true,   // Set isLoading to true
        isError: null,     // Reset isError to null
      };
    case FETCH_CAREER_SUCCESS:
      // When the FETCH_CAREER_SUCCESS action is dispatched
      return {
        ...state,
        isCareerItem: action.payload,  // Update isCareerItem with the payload from the action
        isLoading: false,              // Set isLoading to false
        isError: null,                 // Reset isError to null
      };
    case FETCH_CAREER_FAILURE:
      // When the FETCH_CAREER_FAILURE action is dispatched
      return {
        ...state,
        isLoading: false,              // Set isLoading to false
        isError: action.payload,       // Update isError with the payload from the action
      };
    default:
      // If none of the above action types match, return the current state
      return state;
  }
};

export default CareerDataReducer;
